import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomCheckoutOrderSummaryComponent} from './custom-checkout-order-summary.component';
import {CmsConfig, ConfigModule} from '@spartacus/core';
import {CustomCartSharedModule} from '../../../cart/custom-cart-shared/custom-cart-shared.module';


@NgModule({
  declarations: [CustomCheckoutOrderSummaryComponent],
  imports: [
    CommonModule,
    CustomCartSharedModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutOrderSummary: {
          component: CustomCheckoutOrderSummaryComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCheckoutOrderSummaryModule { }
